












import { Component, Vue, Watch } from 'vue-property-decorator';
import SnackBar from './components/SnackBar.vue';
import { loadLocaleMessagesAsync } from './lib/i18n';
import { namespace } from 'vuex-class';
import { ProfileGetterKeys } from './store/modules/profile';
import { AvailableLocaleCodes, LocaleCode } from './types';
// import { AuthGetterKeys } from './store/modules/auth';

const app = namespace('app');
const auth = namespace('auth');
const alert = namespace('alert');
const profile = namespace('profile');

const CHINESE_CSS_CLASS = 'zh';

@Component({
	components: {
		SnackBar,
	},
})
export default class App extends Vue {
	// TODO: for some mysterious reason, both AuthActionKeys & AuthGetterKeys cannot be used in this file (anything except import), otherwise the whole site will crash.
	// Need to investigate and fix this.
	// @auth.Getter(AuthGetterKeys.isAuthenticated) isAuthenticated!: Function;
	@auth.Getter('isAuthenticated') isAuthenticated!: Function;
	@app.Getter('lang') lang!: LocaleCode;
	@app.Action('setPreferenceLang') setPreferenceLang!: Function;

	@profile.Getter(ProfileGetterKeys.preferences)
	preferences!: { [k: string]: string | number };

	@alert.Getter('text')
	alertText: string | string[] | undefined;

	@alert.Getter('type')
	alertType: string | undefined;

	onSnackClosed() {
		this.$store.dispatch('alert/close');
	}

	delayedAlertText: string | string[] | undefined = '';

	@Watch('preferences')
	onPreferencesUpdate() {
		this.setPreferenceLang({ lang: this.preferences?.language });
	}

	@Watch('lang')
	onLangChange() {
		//for global style depending on lang
		AvailableLocaleCodes.forEach(lang => this.$root.$el.classList.remove(lang));
		this.$root.$el.classList.remove(CHINESE_CSS_CLASS);
		this.$root.$el.classList.add(this.lang);
		if ([LocaleCode.TC, LocaleCode.SC].includes(this.lang)) {
			this.$root.$el.classList.add(CHINESE_CSS_CLASS);
		}
		loadLocaleMessagesAsync(this.lang);
	}

	@Watch('alertText')
	alertTextUpdate() {
		// so that ppl can call close() to stop the alert from being shown by the default axios error alert
		setTimeout(() => {
			if (this.alertType === 'networkError') {
				this.delayedAlertText = this.$t('errors.networkError').toString();
			} else {
				this.delayedAlertText = this.alertText;
			}
		}, 100);
	}

	created() {
		loadLocaleMessagesAsync(this.lang);
		this.onLangChange(); //for edit pages, Watch is not triggered
	}
}
